import { type TravelTransportTypeEnum } from '../enums/TravelTransportTypeEnum'
import { TravelAddress, type TravelAddressConstructor } from '../TravelAddress'

export interface TravelDestinationConstructor {
  id: number
  sequence: number
  transport: TravelTransportTypeEnum
  departurePlaceId: string
  departureReference: string
  departureDate: ISODateString
  departureAddress: TravelAddressConstructor
  arrivalPlaceId: string
  arrivalReference: string
  arrivalDate: ISODateString
  arrivalAddress: TravelAddressConstructor
}

export class TravelDestination {
  readonly id: number
  readonly sequence: number
  readonly transport: TravelTransportTypeEnum
  readonly departurePlaceId: string
  readonly departureReference: string
  readonly departureDate: ISODateString
  readonly departureAddress: TravelAddress
  readonly arrivalPlaceId: string
  readonly arrivalReference: string
  readonly arrivalDate: ISODateString
  readonly arrivalAddress: TravelAddress

  constructor(data: TravelDestinationConstructor) {
    this.id = data.id
    this.sequence = data.sequence
    this.transport = data.transport
    this.departurePlaceId = data.departurePlaceId
    this.departureReference = data.departureReference
    this.departureDate = data.departureDate
    this.departureAddress = new TravelAddress(data.departureAddress)
    this.arrivalPlaceId = data.arrivalPlaceId
    this.arrivalReference = data.arrivalReference
    this.arrivalDate = data.arrivalDate
    this.arrivalAddress = new TravelAddress(data.arrivalAddress)
  }

  // Trip type inference used by the edit-trip modal: return trip when the
  // arrival calendar date differs from the departure date
  get isRoundTrip(): boolean {
    return this.departureDate.slice(0, 10) !== this.arrivalDate.slice(0, 10)
  }
}
